module.exports = (__webpack_require__(0))(9);


//////////////////
// WEBPACK FOOTER
// delegated ./src/router.js from dll-reference girder_lib
// module id = 7
// module chunks = 0